import * as React from "react";
import { Container, createStyles } from "@mantine/core";

import { globalNav, translate, _NavItem } from "./_GlobalNav";
import _ExternalNavElement from "./_ExternalNav";

const useStyles = createStyles((_theme, _params, _getRef) => ({
	navbar: {
		height: 56,
		color: "white",
		display: "flex",
		width: "100%",
		justifyContent: "center",
	},
	container: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		maxWidth: 970,
		width: "76%",
	},
	logo: {
		filter: "invert() contrast(234234)",
		height: 32,
	},
	items: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
	},
}));

interface Props {
	selectedLanguage: "en" | "de" | string;
	languages?: { key: string; label: string }[];
	onLanguageSelect: (language: string) => void;
	organizationNav?: _NavItem[];
	logo: string | undefined;
}

const _TopHeader: React.FC<Props> = ({
	selectedLanguage,
	languages,
	organizationNav,
	logo,
	onLanguageSelect,
}) => {
	const { classes } = useStyles();

	return (
		<Container
			className={classes.navbar}
			fluid={true}
			sx={(theme: any) => {
				return {
					backgroundColor: theme.colors.vsethMain?.[7],
				};
			}}
		>
			<div className={classes.container}>
				<img
					src={
						logo
							? logo
							: "https://static.vseth.ethz.ch/assets/vseth-0000-vseth/logo-mono.svg"
					}
					className={classes.logo}
				/>
				<div className={classes.items}>
					{translate(
						organizationNav ? organizationNav : globalNav,
						selectedLanguage
					).map((item, i) => (
						<_ExternalNavElement
							item={item}
							lightBg={false}
							mobile={false}
							key={i}
						/>
					))}
					{languages ? (
						<_ExternalNavElement
							item={{
								title: selectedLanguage,
								childItems: languages.map((lang) => {
									return {
										title: lang.label,
										onClick: () => onLanguageSelect(lang.key),
									};
								}),
							}}
							lightBg={false}
							mobile={false}
						/>
					) : undefined}
				</div>
			</div>
		</Container>
	);
};

export default _TopHeader;
